import { Button, Col, Container, Row } from "react-bootstrap";
import "../css/footer.css";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../../services/auth";

const Footer = () => {
  const { isAuthenticated, isEnglish } = useContext(AuthContext);
  const auth = useContext(AuthContext);
  const { logout } = auth;
  return (
    <Container fluid className="color_footer bottom-0 p-3 text-center ">
          <Row className="p-2">
            <Col className="py-3">
            <Link to={"/privacy-policy"}>
              <Button
                variant="outline-light"
                className="btn-custom"
              >
                Privacy Policy
              </Button></Link>
            </Col>
            <Col className="py-3">
            <Link to={"/cookie-policy"}>
              <Button
                variant="outline-light"
                className="btn-custom"
              >
                Cookie Policy
              </Button></Link>
            </Col>
            <Col className="py-3">
            <Link to={"/legal-notes"}>
              <Button
                variant="outline-light"
                className="btn-custom"
              >
                {isEnglish ? "Legal notes" : "Note legali"}
              </Button>
              </Link>
            </Col>
            {!isAuthenticated && (
              <Col className="py-3">
                <Link to={"/login"}>
                  <Button
                    variant="outline-light"
                    className="btn-custom"
                  >
                    {isEnglish ? "Login" : "Accedi"}
                  </Button>
                </Link>
              </Col>
            )}
            {isAuthenticated && (
              <Col className="py-3">
                <Link to={"/admin"}>
                  <Button
                    variant="outline-light"
                    className="btn-custom"
                  >
                    Dashboard
                  </Button>
                </Link>
              </Col>
            )}
            {isAuthenticated && (
              <Col className="py-3">
                <Button
                  onClick={() => {
                    logout();
                  }}
                  variant="outline-light"
                  className="btn-custom"
                >
                  Logout
                </Button>{" "}
              </Col>
            )}
          </Row>
      <Row className="text-center text-white">
      <Container className="d-flex justify-content-center align-items-center contain-img h-100 text-white py-3">
            <a
              className="text-white text-decoration-none"
              href="https://www.actainfo.it/"
              target="_blank"
              rel="noreferrer"
            >
              <h6 className="p-0 m-0 user-select-none acta-container" readOnly>
                <span style={{color: '#a9a9a9'}}> Powered by</span>
                <img
                  src="/media/acta_logo_white.png"
                  alt=""
                  className=" object-fit-cover pb-2 img-acta"
                ></img>
              </h6>
            </a>
          </Container>
        <h6 className="opacity-50 custom-button">© Copyright 2014-{new Date().getFullYear()} - Rosella Clementi</h6>
      </Row>
    </Container>
  );
};
export default Footer;
